import React, { Component } from 'react'
import { DragSource } from 'react-dnd'
// import { getEmptyImage } from 'react-dnd-html5-backend'

export default DragSource(
  'square',
  {
    beginDrag: props => {
      return props
    },
  },
  (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
    connectDragPreview: connect.dragPreview(),
  }),
)(
  class Card extends Component {
    // componentDidMount() {
    //   this.props.connectDragPreview(getEmptyImage())
    // }

    render() {
      const isDragging = this.props.isDragging
      const connectDragSource = this.props.connectDragSource

      const style = {
        backgroundColor: this.props.color,
        opacity: isDragging ? 0.5 : 1,
        display: 'inline-block',
        width: 100,
        height: 100,
        margin: 10,
        border: `5px solid ${this.props.borderColor}`,
      }

      return connectDragSource(<div className="square" style={style} />)
    }
  },
)
